import { useEffect } from "react";

import { Navigate, Outlet, useLocation } from "react-router-dom";

import useLesson from "@/contexts/useLesson";
import useVideoContext from "@/hooks/useVideoContext";

const CheckLessonStatus = () => {
  const { lesson } = useLesson();
  const { disconnectFromRoom } = useVideoContext();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const isSandbox =
    searchParams.get("sandbox") === "true" &&
    import.meta.env.VITE_PUBLIC_STAGE !== "production";

  useEffect(() => {
    if (lesson && lesson.hasCompleted && !isSandbox) {
      disconnectFromRoom();
    }
  }, [lesson, disconnectFromRoom, isSandbox]);

  if (lesson && lesson.hasCompleted && !isSandbox) {
    return <Navigate to={`/${lesson.id}/completed`} />;
  } else {
    return <Outlet />;
  }
};

export default CheckLessonStatus;
